// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"705":"d9937f21","865":"5d23003e","879":"e2ae1157"}[chunkId] + ".css";
};